/**
 * jescard brand simple index
 */
export default {
  searchForm: {
    shopLabel: 'My Shop',
    shopPlaceholder: 'Select Shops',
    screenButtonText: 'Settings',
    priceTypeLabel: 'Price Type',
    currLabel: 'Currency',
    TimeLabel: 'Time',
    resetButtonText: 'Reset',
    searchButtonText: 'Submit',
    selectedBrand: 'Brands Selected',
    selectedShop: 'Shops Selected',
    selectedGroup: 'Conditions Selected',
    ruleCurrMsg: 'Please select currency',
    ruleDateMsg: 'Time Setting',
    report: 'Daily Report',
    saveReport: 'Save Daily Report Condition',
    saveReport_text: 'There is currently a daily report, do you want to save it?',
    saveReport_text1: 'There is currently no daily reports. Do you want to save it?',
    saveSuccess: 'Save successful',
    saveError: 'Save failed, please try again later',
    on: 'On',
    off: 'Off',
    onMsg: `The report data includes Top 10 products that with the most price advantage and with the least advantage. 
          All data is extracted based on the conditions you selected on the Brand-Index page on AI Tracking system according 
          to the selected price type throught the formula of dividing the benchmark shop price by comparison mall price. 
          It will send to you via email everyday, if you do not wish to receive the report in the future, please free feel 
          to turn off the subscription button on the Brand-Index page.`,
    onSuccessMsg: 'Open Successfully',
    onFailMsg: 'Please save the selected criteria for the daily report.',
    offSuccessMsg: 'Close Successfully',
    offFailMsg: 'Close Failed',
    screenModal: {
      title: 'Settings',
      subText: 'Confirm',
      closeText: 'Cancel',
      brandLabel: 'Brand Selected：',
      shopLabel: 'Shops Selected：',
      selectShopMsg: 'Select Shops！',
      noBrandSelectMsg: 'Select Brands！',
      noShopSelectMsg: 'Select Comparison Shops！',
      shop: 'Shop',
      selected: 'Selected',
    },
    reportModal: {
      title: 'Daily Report',
      name: 'Name',
      time: 'Time',
      status: 'Status',
      status_all: 'All',
      status_on: 'Sent',
      status_off: 'Not Sent',
      selectDownload: 'Batch Download',
      reportName: 'Report Name',
      sendTime: 'Create Time',
      view: 'View',
      download: 'Download',
    },
  },
  jescAnalysisCard: {
    title: 'Brand Index',
    exportButtonText: 'Download',
    noData: 'No Data',
    chartTitle:
      'The higher the index value, the lower the price of My shop. Click the bar chart to analyze a single shop.',
  },
  brandAnalysisModal: {
    title: 'Brand Analysis',
    exportBtn: 'Download',
    okBtn: 'Close',
    shop: 'Shop：',
    priceType: 'Price Type：',
    tableColumns: {
      category: 'Category',
      index: 'Index',
      operate: 'Operate',
      view: 'View',
    },
  },
  productDetailModel: {
    title: 'Product Detail',
    comparisonShop: 'Comparison Shop：',
    brand: 'Brand：',
    priceType: 'Price Type：',
    curr: 'Currency：',
    lowerTitle: 'SKU Prices Lower Than My Shop',
    higherTitle: 'SKU Prices Higer Than My Shop',
    loadMore: 'Load More',
    noMore: 'No More',
    export: 'Download',
    lower: 'Disadvantaged products',
    high: 'Advantage products',
    keyword: 'Keyword',
    all: 'All',
    tableColumns: {
      brand: 'Brand',
      name: 'Name',
      image: 'Image',
      upc: 'UPC',
      comPrice: 'Comparison shop price',
      myPrice: 'My Shop Price',
      difference: 'Difference',
      differencePercent: 'Difference in %',
      index: 'Index',
    },
  },
};
